import React from "react";
import images from "../../../Utils/importImages";
import "./UserInfoSection.css";
import { useDispatch, useSelector } from "react-redux";

function UserInfoSection() {

    let dispatch = useDispatch();
  
    const { isUserLogin, isAdminLogin, userLoggedInData } = useSelector(
      (state) => state.user
    );

    let getName = () => {
      let name =
        isUserLogin == true
          ? `${userLoggedInData?.user_data?.[0]?.first_name} ${userLoggedInData?.user_data?.[0]?.last_name == null ? "" : userLoggedInData?.user_data?.[0]?.last_name}`
          : userLoggedInData?.fullName;
      return name;
    };
  
    let getEmail = () => {
      return userLoggedInData?.email || "---"
    };

    let getPhone = () => {
    return userLoggedInData?.phone || "---"
    };

  return (
    <div className="userdb-content-left">
      <div className="userdb-content-left-internal">
        <div className="userdb-username">
          <div className="userdefaultimg">
            <img src={images["Symbols.svg"]} alt="" />
          </div>
          {getName()}
        </div>
        <ul className="userdb-personal-detail">
          <li>
            <img src={images["userdb-email.svg"]} alt="" />{" "}
            {getEmail()}
          </li>
          <li>
            <img src={images["userdb-phone.svg"]} alt="" />
            {getPhone()}
          </li>
        </ul>
      </div>
    </div>
  );
}

export default UserInfoSection;
